<script>
    export let label = ''
    export let size = 'default'
    export let style = ''
    export let disabled = false
    export let type = 'primary'
    import Typography from './Typography.svelte'
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    function mousedown() {
        dispatch('mousedown', {})
    }
    function mouseup() {
        dispatch('mouseup', {})
    }
    function mouseover() {
        dispatch('mouseover', {})
    }
    function mouseout() {
        dispatch('mouseout', {})
    }
    function dblclick() {
        dispatch('dblclick', {})
    }
    function click() {
        dispatch('click', {})
    }
    function contextmenu() {
        dispatch('contextmenu', {})
    }
    function keypress(event) {
        if (['Enter', 'Space'].indexOf(event.code) !== -1) click()
    }
</script>

<div
    {style}
    class={`${size} ${type}${disabled ? '-disabled disabled' : ''}`}
    on:keypress={disabled ? (_) => {} : keypress}
    on:click={disabled ? (_) => {} : click}
    on:dblclick={disabled ? (_) => {} : dblclick}
    on:mousedown={disabled ? (_) => {} : mousedown}
    on:mouseup={disabled ? (_) => {} : mouseup}
    on:mouseover={disabled ? (_) => {} : mouseover}
    on:mouseout={disabled ? (_) => {} : mouseout}
    on:contextmenu={disabled ? (_) => {} : contextmenu}
    on:focus={(_) => {}}
    on:blur={(_) => {}}
    tabindex="0"
>
    {#if $$slots}
        <slot />
    {/if}
    <Typography type="button">{label}</Typography>
</div>

<style>
    div {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;
        width: auto;
        user-select: none;
        cursor: pointer;
        border-radius: 8px;
        transition: all 0.25s ease-in-out;
    }
    div:active {
        transform: scale(0.995);
    }
    .disabled {
        cursor: no-drop;
    }
    .disabled:hover {
        transform: none;
    }
    .default {
        padding: 16px 32px;
        min-width: 160px;
        height: 56px;
    }
    .small {
        min-width: 127px;
        padding: 4px 32px 6px;
        height: 32px;
    }

    .primary {
        background: var(--color-brand-primary-01);
        color: var(--color-white);
    }

    .primary:hover {
        background: var(--color-brand-primary-03);
    }

    .primary:active {
        background: var(--color-brand-primary-02);
    }

    .primary-disabled {
        background: rgba(175, 34, 25, 0.2);
        color: var(--color-white);
    }

    .secondary {
        background: white;
        color: var(--color-brand-primary-01);
    }

    .secondary:hover {
        color: var(--color-brand-primary-03);
    }

    .secondary:active {
        color: var(--color-brand-primary-02);
    }

    .secondary-disabled {
        background: var(--color-white-transparent);
        color: rgba(175, 34, 25, 0.2);
    }

    .other {
        background: var(--color-white);
        border: 1px solid var(--color-grey-800);
        color: var(--color-grey-800);
    }

    .other:hover {
        background: var(--color-grey-150);
        border: 1px solid var(--color-grey-800);
        color: var(--color-grey-800);
    }

    .other:active {
        background: var(--color-grey-150);
        border: 1px solid var(--color-grey-400);
        color: var(--color-grey-400);
    }

    .other-disabled {
        background: var(--color-white);
        border: 1px solid var(--color-grey-300);
        color: var(--color-grey-300);
    }

    .transparent {
        border: 1px solid var(--color-white);
        color: var(--color-white);
    }

    .transparent:hover {
        background: var(--color-white-transparent);
    }

    .transparent:active {
        background: var(--color-white-transparent);
        border: 1px solid var(--color-white-transparent);
        color: var(--color-white-transparent);
    }

    .transparent-disabled {
        border: 1px solid var(--color-white-transparent);
        color: var(--color-white-transparent);
    }
</style>
